var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZhengtigaikuo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_29_00530"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 16,
    height: 16,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_29_00530)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.854124126434327,5.891L2.896624126434326,5.891C2.4428741264343263,5.891,2.075374126434326,6.2585,2.075374126434326,6.71225L2.075374126434326,13.1788C2.0753740146753263,13.6325,2.4428741264343263,14,2.896624126434326,14L4.853374126434327,14C5.307874126434326,14,5.675374126434326,13.6325,5.675374126434326,13.1788L5.675374126434326,6.71225C5.675374126434326,6.2585,5.307874126434326,5.891,4.854124126434327,5.891ZM8.976874126434327,2.000000111759L7.023874126434326,2.000000111759C6.568624126434326,2.000000111759,6.200374126434326,2.36825,6.200374126434326,2.8235L6.200374126434326,13.1772C6.200374126434326,13.6318,6.568624126434326,14,7.023874126434326,14L8.977624126434327,14C9.432124126434326,14,9.801124126434326,13.6318,9.801124126434326,13.1765L9.801124126434326,2.8235C9.800714126434325,2.368572,9.431804126434326,2,8.976874126434327,2.000000111759ZM13.104074126434327,8.09375L11.147374126434325,8.09375C10.693624126434326,8.09375,10.326124126434326,8.46125,10.326124126434326,8.915L10.326124126434326,13.178C10.324874126434326,13.6319,10.692714126434327,14.0004,11.146624126434325,14L13.103374126434327,14C13.557174126434326,14,13.924674126434326,13.6325,13.924674126434326,13.1788L13.924674126434326,8.915C13.925474126434326,8.46139,13.557774126434326,8.09333,13.104074126434327,8.09375Z",
    fill: "#CCCCCC",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZhengtigaikuo);
export default __webpack_public_path__ + "static/media/zhengtigaikuo.cf7d8bc3351e2f0c65fe8994e9c2a5a5.svg";
export { ForwardRef as ReactComponent };